import { Localization } from "../../../../../../../OW.Remoting/Remoting/Localization";
import { GenericControl } from "../../../../../../UI.BaseControls/GenericControl";
import { Column } from "../../../../../../UI.Controls/DataGridSubcontrols/Columns/Column";
import { ButtonTemplate } from "../../../../../../UI.Controls/DataGridSubcontrols/Templates/DataTypeTemplates/ButtonTemplate";
import { createElement, registerCustomElement } from "../../../../../../UI.ElementarControls/Utils/CustomElementUtils";
/**
 * Buňka tlačítkového sloupce
 */
export class ButtonCellElement extends HTMLDivElement {
    public get displayedValue(): string {
        return this._textElement.innerText;
    }
    public set displayedValue(v: string) {
        this._textElement.innerText = v;
    }
    private _textElement: HTMLElement;

    constructor(self?: any) {
        super();
        self ? self._constructor() : this._constructor(); // polyfill
    }

    protected _constructor(): void {
        GenericControl._constructor(this as HTMLElement);
    }

    public initialize(column: Column, parent: ButtonTemplate): void {
        this.classList.add("button-template");
        const button = createElement({ type: "button", classes: ["btn", "flat"] }) as HTMLButtonElement;

        button.addEventListener("click", () => {
            if (button.classList.contains("Disabled"))
                return;
            column.callEvent("buttonClicked", {
                id: this.closest(".DataRow").getAttribute("datakey"),
            });
        });
        if (parent.buttonLocKey) //pokud je nastaveno všechny tlačítka ve sloupci mají stejný popisek
            Localization.addLocData(button, parent.buttonLocKey);

        this.appendChild(button);
        this._textElement = createElement({ type:"span" });
        button.appendChild(this._textElement);
    }
}
registerCustomElement("tsc-buttoncell", ButtonCellElement, "div");
